import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import dayjs from 'dayjs';
import { IInputProps, Input } from '@smart-kasa/ui';

import styles from './Datepicker.module.scss';

const DATE_FORMAT = 'd MMMM yyyy';

export interface IDatepicker extends ReactDatePickerProps {
  inputProps?: IInputProps;
}

export const Datepicker = ({
  dateFormat = DATE_FORMAT,
  inputProps,
  selected,
  ...props
}: IDatepicker) => {
  const date = dayjs(selected);

  return (
    <DatePicker
      selected={date.isValid() ? date.toDate() : null}
      dateFormat={dateFormat}
      showMonthDropdown
      showYearDropdown
      customInput={<Input className={styles.input} {...inputProps} />}
      popperPlacement="top-end"
      popperModifiers={{
        preventOverflow: { enabled: true },
      }}
      {...props}
    />
  );
};
